import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Analytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    axios_track();
    async function axios_track() {
      try {
        await fetch(`${API}/api/track`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ path: pathname, ref: document.referrer || "", w: window.innerWidth }),
          keepalive: true,
        });
      } catch {
        /* mesure d'audience silencieuse : ne doit jamais casser la navigation */
      }
    }
  }, [pathname]);

  return null;
}
